import { memo } from 'react';

const DontMissChip = (props) => {
    //Changed JSX of this component and review to bhagyashree ||Azeem K 25-07-2023

    const { value: [...arrDontMiss], nShowChip, bisEnlargementClass } = props;

    return (
        <>

            {(arrDontMiss?.length && nShowChip > 0 ? arrDontMiss?.slice(0, nShowChip) : arrDontMiss)?.map((each, i) => {
                return (
                    <div key={i} className={`chips ${each?.bg_color?.includes('negative') ? 'negative-chip' : (each?.bg_color?.includes('positive') ? 'positive-chip' : (each?.bg_color?.includes('default-chip') ? 'default-chip' : ''))} d-flex  align-items-center me-2 ${bisEnlargementClass ? '' : ''}`}>
                        {each?.icon && <div className={`${each.icon} icon-12 icon-grey float-start me-1`}></div>}   {/* Bhagyashri P [04-01-2024] : Minor class changes */}
                        <div className={``}>{each?.event}</div>   {/* Bhagyashri P [30-11-2023] : BT-109089 Scrip Overview - class changes */}
                    </div>);
            })}
            {arrDontMiss?.length - nShowChip > 0 &&
                <div className='chips-wrap d-flex align-items-center'>
                    <div className={`chips default-chip`}>+{arrDontMiss?.length - nShowChip}</div>
                </div>}

        </>);
};

export default memo(DontMissChip);
